// Auto-generated version file
// Update with: yarn version:bump or node scripts/bump-version.js

export const VERSION = {
  number: "1.3.0",
  build: "202512311445",
  timestamp: Date.now(),
};

export const getVersionString = () => `v${VERSION.number} (${VERSION.build})`;
